export default "__VITE_ASSET__Dvht5MhK__"